// eslint-disable-next-line import/prefer-default-export
export const PACKAGE_COUNT = 'PACKAGE_COUNT';
